import React from 'react';
import style from './style/lsrconclusion.scss';
import { badge__sectionBlock, scoreBlockWhite, sectionBlock_subtitle } from '../Grid/style/grid.scss';

import SectionBlock from '../SectionBlock/SectionBlock';
import LSRScoreArc from './markup/LSRScoreArc';

export const LSRConclusion = (props) => {
    const {
        i18nParticipation,
        icon,
        section
    } = props;

    return (
        <SectionBlock
            classes={ {
                badge: {
                    root: badge__sectionBlock,
                    figure: icon
                },
                root: scoreBlockWhite
            } }
        >
            <span className={ `${sectionBlock_subtitle} ${style.lsr_conclusion_subtitle}` }>
                { section.basedOn || i18nParticipation.report_section_based_on_default_text }
            </span>
            <h3 className={ style.lsr_conclusion_title }>{ i18nParticipation.report_lsr_conclusion }</h3>
            <div className={ style.lsr_conclusion_introduction_wrapper }>
                <LSRScoreArc i18nParticipation={ i18nParticipation } score={ section.scores[0].score } />
                <div className={style.lsr_conclusion_introduction_text} dangerouslySetInnerHTML={ { __html: section.introduction } } />
            </div>
        </SectionBlock>
    );
};
